export default class MathUtility {
  static round = (n: number, digits: number = 3) =>
    Math.round(n * Math.pow(10, digits)) / Math.pow(10, digits);
}
